/* eslint-disable react/prop-types */

import React from 'react';
import { Form } from 'react-bootstrap';

const ErrorFeedback = ({ error, istextAndUnit }) =>
  error && (
    <Form.Control.Feedback
      style={{ display: istextAndUnit ? 'none' : 'block' }}
      type="invalid"
    >
      {error.message}
    </Form.Control.Feedback>
  );

export default ErrorFeedback;
